import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    margin: '30px auto',
    maxWidth: '910px'
  },
  imageContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 284px)',
    justifyContent: 'space-between'
  },
  image: {
    width: '284px',
    height: '148px',
    float: 'left',
    marginBottom: '31px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  },
  buttonImageDelete: {
    marginLeft: '242px',
    marginTop: '6px',
    width: '32px',
    height: '32px',
    color: 'white',
    backgroundColor: 'red',
    borderRadius: '5px',
    paddingTop: '3px',
    paddingBottom: '3px'
  }
}));
